export const en = {
  // Navigation
  nav: {
    ats: "ATS",
    jobPostings: "Job Postings", 
    candidates: "Candidates",
    signIn: "Log In",
    signOut: "Sign Out",
    postJob: "Post a Job",
    findJobs: "Find Jobs",
    companies: "Companies",
    jobAlerts: "Job Alerts",
    superAdmin: "Super Admin"
  },

  // Hero Section
  hero: {
    title: "Find Your Dream Job\nin Sri Lanka",
    subtitle: "Connect with top employers and discover thousands of opportunities on the country's first AI-powered job board",
    searchPlaceholder: "Job title or keywords",
    locationPlaceholder: "Select location",
    jobTypePlaceholder: "Job type",
    searchButton: "Search Jobs",
    stats: {
      activeJobs: "Active Jobs",
      companies: "Companies", 
      jobSeekers: "Job Seekers"
    }
  },

  // Job Card
  jobCard: {
    applyNow: "Apply Now",
    remote: "Remote",
    ago: "ago",
    salary: "Salary"
  },

  // Features Section
  features: {
    title: "Why Choose GreatJobs.lk?",
    subtitle: "The most trusted job platform in Sri Lanka, connecting talent with opportunity.",
    topCompanies: {
      title: "Top Companies",
      description: "Access jobs from Sri Lanka's leading employers"
    },
    aiMatching: {
      title: "A.I. Matching", 
      description: "Smart matching between candidates and job opportunities"
    },
    careerGrowth: {
      title: "Career Growth",
      description: "Find opportunities that advance your career"
    },
    qualityVerified: {
      title: "Quality Verified",
      description: "All job postings are verified and legitimate"
    }
  },

  // Quick Start Section
  quickStart: {
    getStarted: "Get started in seconds",
    payment: "Pay with credit card or crypto",
    getStartedDesc: "Create your account and start posting or applying to jobs instantly",
    paymentDesc: "Flexible payment options for all your hiring needs"
  },

  // Featured Jobs Section
  featuredJobs: {
    title: "Featured Jobs",
    subtitle: "Discover premium opportunities from top employers",
    viewAll: "View All Jobs",
    noJobs: "No featured jobs available at the moment."
  },

  // CTA Section
  cta: {
    title: "Ready to Take Your Career to the Next Level?",
    subtitle: "Join thousands of professionals who have found their dream jobs through GreatJobs.lk.",
    createAccount: "Create Job Seeker Account",
    postFirstJob: "Post Your First Job"
  },

  // Footer
  footer: {
    description: "Sri Lanka's premier AI-powered job portal connecting talent with opportunity.",
    jobSeekers: "For Job Seekers",
    employers: "For Employers", 
    support: "Support",
    browseJobs: "Browse Jobs",
    careerAdvice: "Career Advice",
    resumeBuilder: "Resume Builder",
    postJobs: "Post Jobs",
    searchCandidates: "Search Candidates",
    atsIntegration: "ATS Integration",
    pricing: "Pricing",
    helpCenter: "Help Center",
    contactUs: "Contact Us",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    yourSafety: "Your Safety",
    copyright: "All rights reserved."
  },

  appliedJobs: {
    title: "Applied Jobs",
    description: "Track and manage all your job applications",
    noApplications: "No applications found",
    noApplicationsDescription: "You haven't applied to any jobs yet. Start exploring opportunities!",
    searchPlaceholder: "Search by job title, company, or location...",
    filterByStatus: "Filter by status",
    allStatus: "All Status",
    pending: "Pending",
    shortlisted: "Shortlisted", 
    interviewing: "Interviewing",
    offerMade: "Offer Made",
    rejected: "Rejected",
    withdrawn: "Withdrawn",
    appliedAgo: "Applied",
    match: "Match",
    coverLetter: "Cover Letter",
    cvAttached: "CV Attached",
    viewJob: "View Job",
    downloadCv: "Download CV",
    withdraw: "Withdraw",
    withdrawing: "Withdrawing...",
    withdrawTitle: "Withdraw Application", 
    withdrawDescription: "Are you sure you want to withdraw your application for \"{jobTitle}\"? This action cannot be undone.",
    withdrawSuccess: "Application withdrawn successfully",
    withdrawError: "Failed to withdraw application",
    loadError: "Failed to load your applications",
    browseJobs: "Browse Jobs",
    previous: "Previous",
    next: "Next",
    pageOf: "Page {current} of {total}",
    remote: "Remote"
  },

  // Job Management
  jobManagement: {
    title: "Job Management",
    subtitle: "Manage your job listings and track performance",
    postNewJob: "Post New Job",
    noJobsTitle: "No job listings yet",
    noJobsDescription: "Start by posting your first job listing",
    postFirstJob: "Post Your First Job",
    view: "View",
    edit: "Edit",
    delete: "Delete",
    aiMatch: "AI Match",
    applications: "applications",
    posted: "Posted",
    salary: "Salary",
    salaryNotSpecified: "Salary not specified",
    jobDetails: "Job Details",
    description: "Description",
    requirements: "Requirements",
    benefits: "Benefits",
    skills: "Skills",
    deleteConfirmTitle: "Delete Job Listing",
    deleteConfirmDescription: "Are you sure you want to delete this job listing? This action cannot be undone.",
    cancel: "Cancel",
    confirm: "Delete",
    deleteSuccess: "Job listing deleted successfully",
    deleteError: "Failed to delete job listing",
    aiMatchingTitle: "AI-Matched Candidates",
    aiMatchingSubtitle: "Top candidates matched using artificial intelligence",
    upgradeRequired: "Upgrade Required",
    aiMatchingUpgradeMessage: "AI matching is only available for BPO & Bulk Plan and Enterprise Annual plans",
    matchPercentage: "Match %",
    experience: "Experience",
    viewCV: "View CV",
    years: "years",
    noMatchedCandidates: "No matched candidates found",
    fetchingCandidates: "Fetching suitable candidates...",
    fetchCandidatesError: "Failed to fetch suitable candidates",
    loadingJobs: "Loading job listings...",
    fetchJobsError: "Failed to fetch job listings"
  },

  // ATS (Applicant Tracking System)
  ats: {
    title: "Applicant Tracking System",
    subtitle: "Manage applications and shortlisted candidates",
    jobApplications: "Job Applications",
    shortlistedCandidates: "Shortlisted Candidates",
    selectJobListing: "Select a job listing",
    allApplications: "All Applications",
    pending: "Pending",
    reviewing: "Reviewing",
    shortlisted: "Shortlist",
    rejected: "Reject",
    hired: "Hired",
    loadingApplications: "Loading applications...",
    noApplicationsFound: "No applications found for this filter",
    match: "Match",
    calculateMatch: "Calculate Match",
    appliedOn: "Applied on",
    viewApplication: "View Application",
    viewCV: "View CV",
    updateStatus: "Update Status",
    addNotes: "Add Notes",
    notesPlaceholder: "Add notes about this application...",
    updateStatusSuccess: "Application status updated to",
    updateStatusError: "Failed to update application status",
    matchCalculateSuccess: "Match score calculated:",
    matchCalculateError: "Failed to calculate match score",
    openCVError: "Failed to open CV",
    coverLetter: "Cover Letter",
    candidateName: "Candidate Name",
    contactedOn: "Contacted on",
    notContacted: "Not contacted",
    sample: "Sample",
    fetchJobsError: "Failed to fetch your job listings",
    fetchApplicationsError: "Failed to fetch applications",
    shortlistedCandidatesCount: "Shortlisted Candidates",
    searchMoreCandidates: "Search More Candidates",
    noShortlistedTitle: "No candidates shortlisted yet",
    noShortlistedDescription: "Use the candidate search feature to find and shortlist potential candidates.",
    searchCandidates: "Search Candidates",
    shortlistedOn: "Shortlisted on",
    experience: "Experience",
    notice: "Notice",
    keySkills: "Key Skills",
    notes: "Notes",
    viewProfile: "View Profile",
    contacted: "Contacted",
    contact: "Contact",
    contactSuccess: "Candidate contacted successfully",
    contactError: "Failed to update contact status",
    cvAvailable: "CV Available",
    years: "years"
  },

  // Candidate Search
  candidateSearch: {
    title: "Search Filters",
    requiredFields: "Required: Enter either (Job Title + Experience Level) OR Skills/Keywords",
    jobTitle: "Job Title",
    jobTitlePlaceholder: "e.g. Software Engineer",
    experienceLevel: "Experience Level",
    experienceLevelPlaceholder: "Select experience level",
    skillsKeywords: "Skills/Keywords",
    skillsPlaceholder: "e.g. React, Node.js, Python",
    additionalFilters: "Additional Filters (Optional)",
    candidateName: "Candidate Name",
    candidateNamePlaceholder: "Enter name...",
    availableOverseas: "Available Overseas",
    availabilityPlaceholder: "Select availability",
    visaStatus: "Visa Status",
    visaStatusPlaceholder: "Select visa status",
    searchCandidates: "Search Candidates",
    resetFilters: "Reset Filters",
    experienceLevels: {
      entry: "Entry Level",
      mid: "Mid Level",
      senior: "Senior Level",
      lead: "Lead/Manager",
      executive: "Executive"
    },
    availability: {
      all: "All",
      yes: "Yes",
      no: "No"  
    },
    visaStatuses: {
      all: "All",
      citizen: "Citizen",
      permanent_resident: "Permanent Resident",
      work_visa: "Work Visa",
      student_visa: "Student Visa",
      tourist_visa: "Tourist Visa",
      none: "No Visa"
    },
    readyToSearch: "Ready to search for candidates",
    searchInstruction: "Enter either a job title with experience level, or skills/keywords to begin your search.",
    searchError: "Please enter either (Job Title + Experience Level) or Skills/Keywords to search",
    loadingAuth: "Loading authentication...",
    redirecting: "Redirecting...",
    shortlist: "Shortlist",
    contact: "Contact",
    viewCV: "View CV",
    shortlisted: "Shortlisted",
    contacted: "Contacted",
    years: "years",
    experience: "Experience",
    keySkills: "Key Skills",
    location: "Location",
    overseas: "Global",
    visa: "Visa",
    noResults: "No candidates found",
    searchErrorMessage: "Try adjusting your search filters to find more candidates."
  },

  // Payment & Checkout
  payment: {
    orderSummary: "Order Summary",
    selectedPlan: "Selected Plan",
    planPrice: "Plan Price:",
    addons: "Add-ons:",
    addonsSubtotal: "Add-ons Subtotal:",
    billing: "Billing:",
    duration: "Duration:",
    total: "Total:",
    paymentDetails: "Payment Details",
    billingEmail: "Billing email",
    selectPaymentMethod: "Select Payment Method",
    creditCard: "Credit Card",
    viaStripe: "Via Stripe",
    usdt: "USDT",
    viaCoinbase: "Via Coinbase",
    secureStripePayment: "Secure Payment with Stripe",
    stripeDescription: "Your payment will be processed securely through Stripe",
    payWithUsdt: "Pay with USDT",
    coinbaseDescription: "Secure USDT payments powered by Coinbase Commerce",
    processing: "Processing...",
    proceedToPayment: "Proceed to Payment",
    termsNotice: "By proceeding, you agree to our terms of service and privacy policy. Your subscription will automatically renew unless cancelled.",
    loadingCheckout: "Loading checkout...",
    oneTimePayment: "One-time payment",
    perMonth: "per month",
    perYear: "per year",
    days: "days"
  },

  // Post Job
  postJob: {
    jobDetails: "Job Details",
    unlimitedJobs: "Unlimited jobs",
    jobsUsed: "jobs used",
    company: "Company",
    selectCompany: "Select a company",
    newCompany: "New Company",
    createNewCompany: "Create New Company",
    cancel: "Cancel",
    companyLogo: "Company Logo",
    uploadLogo: "Upload Logo",
    uploading: "Uploading...",
    imageFormats: "PNG, JPG up to 5MB",
    companyName: "Company Name *",
    companyNamePlaceholder: "Enter company name",
    website: "Website",
    websitePlaceholder: "https://company.com",
    industry: "Industry",
    industryPlaceholder: "e.g., Technology, Finance",
    companySize: "Company Size",
    selectSize: "Select size",
    employees1to10: "1-10 employees",
    employees11to50: "11-50 employees",
    employees51to200: "51-200 employees",
    employees201to500: "201-500 employees",
    employees500plus: "500+ employees",
    companyDescription: "Company Description",
    companyDescriptionPlaceholder: "Brief description of the company",
    createCompany: "Create Company",
    jobTitle: "Job Title *",
    jobTitlePlaceholder: "e.g., Senior Software Engineer",
    location: "Location *",
    locationPlaceholder: "e.g., Colombo, Sri Lanka",
    jobType: "Job Type *",
    selectJobType: "Select job type",
    fullTime: "Full-time",
    partTime: "Part-time",
    contract: "Contract",
    internship: "Internship",
    experienceLevel: "Experience Level *",
    selectExperienceLevel: "Select experience level",
    entryLevel: "Entry-level",
    midLevel: "Mid-level",
    senior: "Senior",
    executive: "Executive",
    minSalary: "Minimum Salary (LKR/month)",
    minSalaryPlaceholder: "e.g., 50000",
    maxSalary: "Maximum Salary (LKR/month)",
    maxSalaryPlaceholder: "e.g., 80000",
    remoteWork: "Remote work available",
    urgentHiring: "Mark as urgent hiring",
    urgentBadgeActive: "Urgent Badge Active",
    addUrgentBadge: "Add urgent hiring badge",
    urgentPaymentNotice: "You'll be redirected to payment before posting this urgent job.",
    requiredSkills: "Required Skills (comma-separated)",
    skillsPlaceholder: "e.g., React, Node.js, PostgreSQL",
    applicationDeadline: "Application Deadline",
    jobDescription: "Job Description *",
    jobDescriptionPlaceholder: "Describe the role, responsibilities, and what you're looking for...",
    requirements: "Requirements",
    requirementsPlaceholder: "List the required qualifications, experience, and skills...",
    benefits: "Benefits",
    benefitsPlaceholder: "List the benefits, perks, and compensation details...",
    postJob: "Post Job",
    payAndPostUrgent: "Pay & Post Urgent Job",
    processing: "Processing...",
    jobPostingLimitReached: "Job Posting Limit Reached",
    limitReachedMessage: "You've used all {count} job posting{plural} in your {plan} plan",
    upgradePlan: "Upgrade Plan",
    almostAtLimit: "Almost at your limit",
    limitWarningMessage: "You have {count} job posting{plural} remaining in your {plan} plan",
    viewUpgrades: "View Upgrades",
    loading: "Loading..."
  },

  // Testimonials
  testimonials: {
    title: "Why Professionals Choose Sri Lanka's First AI-powered Talent Solution",
    subtitle: "Join thousands of professionals who found their dream jobs through the best job board Sri Lanka trusts",
    testimonial1: {
      name: "Ravindu Perera",
      role: "Software Engineer",
      company: "TechFlow Solutions",
      content: "Found my dream Colombo IT job within 2 weeks! The AI matching feature is incredible - it connected me with opportunities I wouldn't have found elsewhere. This is definitely the best job board Sri Lanka has to offer."
    },
    testimonial2: {
      name: "Samantha Fernando",
      role: "Finance Executive", 
      company: "Lanka Bank",
      content: "As a fresh graduate, I was struggling to find entry level finance jobs Sri Lanka. GreatJobs.lk's targeted matching helped me land my first role at a leading bank. The platform truly understands what employers are looking for."
    },
    testimonial3: {
      name: "Kasun Silva",
      role: "HR Manager",
      company: "Creative Digital", 
      content: "We've tried many platforms, but GreatJobs.lk stands out as Sri Lanka's first AI job board that actually delivers quality candidates. The Colombo IT jobs we post here get the best responses from skilled developers."
    },
    testimonial4: {
      name: "Nimali Jayasinghe",
      role: "Marketing Specialist",
      company: "Growth Labs",
      content: "The job alert system is fantastic! I get notified about relevant opportunities in real-time. It's clear why this is considered the best job board Sri Lanka has - the user experience is unmatched."
    },
    testimonial5: {
      name: "Chathura Mendis",
      role: "Data Analyst",
      company: "Analytics Pro",
      content: "After months of searching traditional job sites, I discovered GreatJobs.lk. Within days, I had interviews lined up for Colombo IT jobs that perfectly matched my skills. The AI technology really works!"
    },
    testimonial6: {
      name: "Priyanka Wickramasinghe",
      role: "Financial Analyst",
      company: "Investment Partners",
      content: "Starting my career was challenging until I found this platform. The entry level finance jobs Sri Lanka section had exactly what I needed. The detailed job descriptions and company profiles made applying so much easier."
    }
  },

  // ATS Integration
  atsIntegration: {
    title: "Complete ATS Built Right In",
    subtitle: "Why integrate with external systems when you can have everything you need built-in? GreatJobs.lk provides a comprehensive applicant tracking system designed specifically for efficient hiring.",
    badge: "No External ATS Required",
    builtInFeatures: {
      title: "Get Started in Minutes",
      description: "Skip the complex integrations and lengthy setup processes. Start hiring immediately with our intuitive, all-in-one platform that grows with your business needs.",
      postFirstJob: "Post Your First Job",
      browseCandidates: "Browse Candidates",
      jobManagement: {
        title: "Complete Job Management",
        description: "Post, edit, and manage job listings with advanced targeting options and real-time analytics"
      },
      candidateSearch: {
        title: "Advanced Candidate Search", 
        description: "Search through thousands of qualified candidates with AI-powered matching and filtering"
      },
      applicantTracking: {
        title: "Applicant Tracking",
        description: "Track applications, manage candidate pipelines, and collaborate with your hiring team"
      },
      analytics: {
        title: "Hiring Analytics",
        description: "Get detailed insights on job performance, candidate quality, and hiring metrics"
      },
      notifications: {
        title: "Smart Notifications",
        description: "Automated SMS and email notifications to candidates on application status updates and new opportunities"
      },
      shortlisting: {
        title: "Candidate Shortlisting",
        description: "Save and organize promising candidates with notes and rating systems"
      }
    },
    externalIntegrations: {
      title: "Plus External Integrations Available",
      description: "Already using an external ATS? No problem. We also offer seamless integrations with leading platforms.",
      benefits: {
        sync: {
          title: "Instant Synchronization",
          description: "Real-time data sync between GreatJobs.lk and your ATS platform"
        },
        security: {
          title: "Secure Data Transfer", 
          description: "Enterprise-grade security with encrypted API connections"
        },
        workflow: {
          title: "Streamlined Workflow",
          description: "Eliminate manual data entry and reduce time-to-hire"
        },
        compliance: {
          title: "Compliance Ready",
          description: "Maintain GDPR and local compliance standards automatically"
        }
      }
    },
    supportedPlatforms: {
      title: "Supported ATS Platforms",
      description: "We integrate with leading Applicant Tracking Systems to ensure seamless workflow compatibility.",
      workday: {
        name: "Workday",
        description: "Complete HCM integration with real-time sync",
        features: ["Candidate sync", "Job posting automation", "Analytics integration"]
      },
      bamboohr: {
        name: "BambooHR",
        description: "All-in-one HR platform integration", 
        features: ["Employee onboarding", "Performance tracking", "Document management"]
      },
      greenhouse: {
        name: "Greenhouse",
        description: "Advanced recruiting software connectivity",
        features: ["Interview scheduling", "Scorecard integration", "Pipeline management"]
      },
      lever: {
        name: "Lever", 
        description: "Modern talent acquisition platform",
        features: ["CRM integration", "Collaborative hiring", "Data analytics"]
      },
      icims: {
        name: "iCIMS",
        description: "Comprehensive talent cloud solution",
        features: ["Talent acquisition", "Workforce management", "Compliance tracking"]
      },
      smartrecruiters: {
        name: "SmartRecruiters",
        description: "Enterprise recruiting platform",
        features: ["Global hiring", "AI-powered matching", "Vendor management"]
      }
    },
    cta: {
      title: "Ready to Integrate Your ATS?",
      description: "Get started with our comprehensive integration platform and transform your hiring process today.",
      signUp: "Sign Up Now"
    }
  },

  // Common
  common: {
    loading: "Loading...",
    search: "Search",
    location: "Location",
    jobType: "Job Type",
    experienceLevel: "Experience Level",
    fullTime: "Full-time",
    partTime: "Part-time", 
    contract: "Contract",
    freelance: "Freelance",
    internship: "Internship",
    entry: "Entry-level",
    mid: "Mid-level",
    senior: "Senior",
    executive: "Executive",
    active: "Active",
    paused: "Paused",
    closed: "Closed",
    remote: "Remote"
  }
};